import React from 'react';
import { TemplateContent } from './TemplateContent';

export const PageTemplate = (props: TemplateContent) => {
    const aside = props.asideNotes != undefined && props.asideNotes != null ?
        (<div className="mt-6 lg:ml-4 lg:mt-0">
            {props.asideNotes.map((e, i) =>
                <div key={i} className="bg-mainBlue text-black p-4 text-center">
                    {e}
                </div>)}
        </div>)
        : <></>

    const fullpage = props.asideNotes == undefined || props.asideNotes == null;

    return (
        <div id={props.pageId} className="grid grid-cols-1 lg:grid-cols-3 bg-gray-300 text-black pt-4 pb-8 px-3 xl:px-12">
            <div className={"text-center lg:text-justify " + (fullpage ? "lg:col-span-3" : "lg:col-span-2")}>
                <h1 className="text-4xl text-center mt-6 mb-4">{props.title}</h1>
                <div className='w-full md:w-2/3 m-auto'>
                    {props.mainContent}
                </div>
            </div>
            {aside}
        </div>
    )
}